












import { Prop, Component, Vue } from 'vue-property-decorator';

@Component({
    name: 'checkradio',
})
export default class Navbar extends Vue {
    @Prop(String) public readonly value!: string;
    @Prop(Array) public readonly options!: string[];
    @Prop(String) public readonly tema!: string;

    private checkOption(e: string) {
        this.$emit('input', e);
    }

}
